/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { ParsedUrlQuery } from 'querystring';

export type DuplicateSkuQueryParams = {
  partGroupId: string | undefined;
  brandId: string | undefined;
  positionId: string | undefined;
  uniqueId: string | undefined;
};

export const getDuplicateSkuQueryParams = (query: ParsedUrlQuery): DuplicateSkuQueryParams => {
  const { productPartGroupId, productBrandId, productPositionId, productUniqueId } = query;

  return {
    partGroupId: Array.isArray(productPartGroupId) ? productPartGroupId[0] : productPartGroupId,
    brandId: Array.isArray(productBrandId) ? productBrandId[0] : productBrandId,
    positionId: Array.isArray(productPositionId) ? productPositionId[0] : productPositionId,
    uniqueId: Array.isArray(productUniqueId) ? productUniqueId[0] : productUniqueId,
  };
};
